import React, { FC, ReactNode } from 'react';
import styled from '@emotion/styled';
import { mq } from '$lib/helpers';

type Props = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data?: any;
};

export const DataTable: FC<Props> = ({ data }) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const recursiveCell = (data: any): ReactNode => {
        const isNode = data && typeof data === 'object';

        return !isNode ? (
            <CellValue>{data}</CellValue>
        ) : (
            Object.entries(data).map(([key, value]) =>
                key.match(/^-?\d+$/) ? (
                    <>{recursiveCell(value)}</>
                ) : (
                    <Row key={key}>
                        <Cell>
                            <CellValue>{key}</CellValue>
                        </Cell>
                        <Cell style={{ width: '100%' }}>{recursiveCell(value)}</Cell>
                    </Row>
                )
            )
        );
    };

    return (
        <Table>
            {Object.entries(data).map(([key, value]) => (
                <OuterRow key={key}>
                    <Cell>
                        <CellValue>{key}</CellValue>
                    </Cell>
                    <Cell>{recursiveCell(value)}</Cell>
                </OuterRow>
            ))}
        </Table>
    );
};

const Table = styled.table(({ theme }) => ({
    border: `1px solid ${theme.colors.grey15}`,
    marginBottom: theme.space[8],
    fontSize: theme.fontSizes.xxs,
    maxWidth: '100%',

    [mq('md')]: {
        fontSize: theme.fontSizes.sm,
    },
    [mq('lg')]: {
        fontSize: theme.fontSizes.default,
    },
}));

const OuterRow = styled.tr(({ theme }) => ({
    borderBottom: `1px solid ${theme.colors.grey15}`,
    '&:nth-child(odd)': {
        backgroundColor: theme.colors.white,
    },
    '&:nth-child(even)': {
        backgroundColor: theme.colors.grey5,
    },
}));

const Row = styled.tr(({ theme }) => ({
    '&:nth-child(odd)': {
        backgroundColor: theme.colors.white,
    },
    '&:nth-child(even)': {
        backgroundColor: theme.colors.grey5,
    },

    '&:not(:first-child)': {
        borderTop: `1px solid ${theme.colors.grey15}`,
    },
    '&:not(:last-child)': {
        borderBottom: `1px solid ${theme.colors.grey15}`,
    },
}));

const CellValue = styled.div(({ theme }) => ({
    padding: `${theme.space[1]} ${theme.space[2]}`,
}));

const Cell = styled.td(({ theme }) => ({
    '&:first-child': {
        fontWeight: theme.fontWeights.medium,
    },
    '&:not(:first-child)': {
        borderLeft: `1px solid ${theme.colors.grey15}`,
    },
    '&:not(:last-child)': {
        borderRight: `1px solid ${theme.colors.grey15}`,
    },
}));
